import apiService from '../../../services/api'

/**
 * Crypto Withdraw API
 * Сервис для вывода кристаллов в криптовалюте (USDT)
 * Документация: docs/crypto_withdraw.md (гайд для фронтенда)
 *
 * Два эндпоинта:
 * - GET /api/crypto-withdraw/ — всё для экрана (info + history)
 * - POST /api/crypto-withdraw/ — создать заявку на вывод
 */

/**
 * Получить данные экрана вывода: info + история заявок
 * @returns {Promise<Object>} { info: {...}, history: [...] }
 */
const fetchCryptoWithdrawData = async () => {
  const response = await apiService.makeRequest('/api/crypto-withdraw/')
  return response
}

/**
 * Создать заявку на вывод кристаллов в криптовалюте
 * @param {Object} params — параметры заявки
 * @param {string} params.asset — код валюты из assets[].asset (по умолчанию USDT)
 * @param {string} params.network — код сети из assets[].networks[].code (trc20, ton, erc20, bep20)
 * @param {string} params.address — адрес кошелька
 * @param {number} params.crystals — сумма в кристаллах
 * @returns {Promise<Object>} { id, asset, network, amount_minor, amount, crystals, status }
 */
const createCryptoWithdraw = async ({ asset, network, address, crystals }) => {
  const response = await apiService.makeRequest('/api/crypto-withdraw/', {
    method: 'POST',
    body: JSON.stringify({
      asset,
      network,
      address,
      crystals,
    }),
  })
  return response
}

export default {
  fetchCryptoWithdrawData,
  createCryptoWithdraw,
}
